import LoopBackEndpoint from './LoopBackEndpoint';
import { loopBackApi } from '../Api/LoopBackApi';

class ReviewEndpoint extends LoopBackEndpoint {
  public constructor() {
    super('reviews', 'id');
  }

  create(data) {
    const base = this.pickMatching(data, this.getBaseFields());
    const promises: any[] = [];

    if (Object.keys(base).length > 0) {
      promises.push(this.post(data));
    }

    return Promise.all(promises);
  }

  post(data) {
    return loopBackApi().post(this.getEndPoint(), data);
  }

  patch(base, rowData) {
    const id = rowData[this.getIndexKey()];
    return loopBackApi().patch(this.getPatchEndPoint(id), base);
  }

  update(changedData: {}, rowData) {
    const base = this.pickMatching(changedData, this.getBaseFields());
    const promises: any[] = [];
    if (Object.keys(base).length > 0) {
      promises.push(this.patch(base, rowData));
    }

    return Promise.all(promises);
  }

  protected getBaseFields() {
    return [
      'rating',
      'remarks',
      'week',
      'camasys_dish_id',
      'camasys_dish_name',
      'camasys_delivery_id'
    ];
  }

  protected getRelationFields() {
    return [];
  }
}

export default ReviewEndpoint;
